// Only format-2 (current schema) template forms are offered in the picker;
// format-1 survey.js templates are skipped.
export default function mapTemplateForms(data) {
  const templates = [];
  ((data && data.forms) || []).forEach((form) => {
    let formJson = form.form_data;
    if (typeof formJson === 'string') {
      try { formJson = JSON.parse(formJson); } catch (e) { formJson = null; }
    }
    if (formJson && formJson.version === 2) {
      templates.push({
        formId: form.form_id,
        name: form.name,
        previewImageUrl: form.preview_image_url || null,
        formJson,
      });
    }
  });
  return templates;
}
